import React from 'react'
import { useTranslate } from 'react-admin'
import {
  TooltipContainer,
  TooltipDescriptionCell,
  TooltipFooter,
  TooltipHeader,
  TooltipLabel,
  TooltipRow,
  TooltipTable,
} from '../ProjectConfigurations.styles'

export const BatteryReplacementModellingTooltip: React.FC = () => {
  const translate = useTranslate()

  const options = [
    {
      label: translate('Remove'),
      description: translate(
        'Battery is removed from the system at the end of life. No replacement occurs and the battery provides no further value.'
      ),
    },
    {
      label: translate('Replace'),
      description: translate(
        'Battery is replaced at the end of life. The replacement cost is calculated using the method specified.'
      ),
    },
    {
      label: translate('Extend Beyond Warranty'),
      description: translate(
        'Battery continues to operate beyond the end of life threshold. No further replacement occurs.'
      ),
    },
  ]

  return (
    <TooltipContainer>
      <TooltipHeader>{translate('Battery Replacement Modelling Options:')}</TooltipHeader>
      <TooltipTable>
        {options.map((option, index) => (
          <TooltipRow key={index}>
            <TooltipLabel>{option.label}</TooltipLabel>
            <TooltipDescriptionCell>{option.description}</TooltipDescriptionCell>
          </TooltipRow>
        ))}
      </TooltipTable>
      <TooltipFooter>
        {translate(
          'When replacement is selected, the replacement cost is calculated using one of three methods: Component cost (pre-inflation) (original purchase price adjusted by annual inflation rate), Manual cost (pre-inflation) (fixed override value adjusted by annual inflation rate), or Cost per kWh Inflation Adjusted (cost per kWh capacity adjusted by annual inflation rate).'
        )}
      </TooltipFooter>
    </TooltipContainer>
  )
}
